<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(addNewData)">
        <div class="form-wrapper" style="width: auto;margin-top: 15px">
          <div class="flex-container">
            <div class="flex-row">
              <div class="key">
                <p class="input-label">
                  Name
                  <span class="field-required">*</span>
                </p>
              </div>
              <div class="value input-expanded">
                <ValidationProvider
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                  style="width: 100%"
                >
                  <b-input
                    v-model="data.name"
                    :disabled="
                      data.name == 'Super Admin' || data.name == 'Admin'
                    "
                    expanded
                    placeholder="name"
                  ></b-input>
                  <p class="notif has-text-danger required">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </div>
            </div>

            <div class="flex-row">
              <div class="key">
                <p class="input-label">
                  Description
                  <span class="field-required">*</span>
                </p>
              </div>
              <div class="value input-expanded">
                <ValidationProvider
                  name="description"
                  rules="required"
                  v-slot="{ errors }"
                  style="width: 100%"
                >
                  <b-field :type="errors.length > 0 ? 'is-danger' : null">
                    <b-input
                      type="textarea"
                      name="description"
                      v-model="data.description"
                    >
                      {{ data.description || '' }}
                    </b-input>
                  </b-field>
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="flex-row">
              <div class="key">
                <p class="input-label">
                  Access
                  <span class="field-required">*</span>
                </p>
              </div>
              <div class="value input-expanded">
                <ValidationProvider
                  name="access"
                  rules="required"
                  v-slot="{ errors }"
                  style="width: 100%"
                >
                  <b-field :type="errors.length > 0 ? 'is-danger' : null">
                    <b-select
                      multiple
                      :native-size="access.length"
                      name="access"
                      v-model="data.access"
                    >
                      <option
                        v-for="acc in access"
                        :key="acc.id"
                        :value="acc.id"
                      >
                        {{ acc.name }} -
                        {{ acc.parentId == 0 ? 'Menu' : 'Sub Menu' }}
                      </option>
                    </b-select>
                  </b-field>
                  <span class="required">{{ errors[0] }}</span>
                  <span style="font-size: 12px;">
                    Press CTRL + Click for select multiple
                  </span>
                </ValidationProvider>
              </div>
            </div>

            <b-button
              native-type="submit"
              type="is-hcc"
              expanded
              style="font-weight: bold"
            >
              {{ editData == null ? 'Add' : 'Edit' }}
            </b-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <b-loading
      :is-full-page="false"
      v-model="isLoading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    editData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      access: [],
      data: {
        id: null,
        name: null,
        description: '',
        access: [],
      },
    }
  },
  mounted() {
    if (this.editData != null) {
      this.data.id = this.editData.id;
      this.data.name = this.editData.name;
      this.data.description = this.editData.description;
      this.data.access = this.editData.access;
    }

    this.getAccess()
  },
  methods: {
    ...mapActions({
      fetchRole: 'newRole/fetchRole',
      createRole: 'newRole/createRole',
      updateRole: 'newRole/updateRole',
      fetchAll: 'newAccess/fetchAll',
    }),
    async getAccess() {
      const response = await this.fetchAll()
      this.access = response.data
    },
    async addNewData() {
      let data = {
        id: this.data.id,
        name: this.data.name,
        access: this.data.access,
        description: this.data.description,
      }
      this.isLoading = true
      try {
        if (this.editData == null) {
          await this.createRole(data)
          this.success('Create Role Success')
        } else {
          await this.updateRole(data)
          this.success('Update Role Success')
        }
        this.isLoading = false
        this.$emit('close-modal', { reload: true })
      } catch (err) {
        this.danger(err.response.data.message)
        this.isLoading = false
      }
    },
    success(message) {
      this.$buefy.toast.open({
        message: message,
        type: 'is-success',
      })
    },
    danger(message) {
      this.$buefy.toast.open({
        message: message,
        type: 'is-danger',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.input-expanded .control {
  width: 100%;
}

.flex-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
}

.flex-row {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: left;
  width: 100%;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.key p {
  text-align: left;
  min-width: 200px;
  font-weight: bold;
  color: #000000;
}

.value {
  display: flex;
  flex: 1;
}

.notif {
  text-align: left;
  font-size: 12px;
}
</style>
